module.exports = __webpack_public_path__ + "img/wang.370da9fc.jpg";